import * as React from 'react';
import type { IconProps } from './types';

export const VizitLogoMark = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => {
  const { color = 'currentColor', height = 22, width = 20, ...other } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={forwardedRef}
    >
      <path d="M16.0884 0L9.9933 20.0738L3.91159 0H0L6.55057 22H13.436L20 0H16.0884Z" fill={color} />
    </svg>
  );
});

VizitLogoMark.displayName = 'VizitLogoMark';
